import { AxiosResponse } from 'axios';
export const getApiResponseData = (response: AxiosResponse<any, any>) => {
    return { success: response.data.success, data: response.data.data, errors: response.data.errors, message: response.data.message, status: response.status }
}